module.exports = __webpack_public_path__ + "img/ic_status_start.5dbd1401.svg";